import { boroughBoundaryLayer, initialCenterWCC } from '@utils';
import * as ELG from 'esri-leaflet';
import { LatLngTuple } from 'leaflet';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

export const EsriTileLayer = () => {
  const map = useMap();
  map.attributionControl.setPrefix(false);
  const streetLayer = ELG.basemapLayer('Streets');
  useEffect(() => {
    map.addLayer(streetLayer);
    map.setView(initialCenterWCC as LatLngTuple);
    map.addLayer(boroughBoundaryLayer);
  }, []);

  return null;
};
